class Point {
    constructor(ctx, x, y, size, color, gravity) {

        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.size = size;
        this.color = color;

        if(gravity => 2 && gravity <= 5) {
            this.gravity = Math.cos(gravity) * Math.random()

        } else if(gravity => 6 && gravity <= 10) {
            this.gravity = Math.sin(gravity) * Math.random()
        } else if(gravity => -10 && gravity <= 1) {
            this.gravity = -1
        }
        
            // } else {
        //     this.gravity = -1
        // }
      

        this.max = 2
        this.min = 1

        this.lifespan = Math.floor(Math.random() * (this.max - this.min + 1) + this.min);

        this.direction = Math.random() * Math.PI * 2 * 2
        
        

     

    }

    update() {
        this.x += Math.cos(this.direction)
        this.y -= this.gravity
        //this.y += Math.sin(this.direction)
        this.lifespan -= 0.002
    
    }

    draw() {
        this.update()
        
        this.ctx.save()
        this.ctx.translate(this.x, this.y)
        this.ctx.beginPath()
        //this.ctx.fillStyle = `rgb(38,128,116)` 
        // this.ctx.fillStyle = `rgb(104,6,222)` 
        // this.ctx.fillStyle = `rgb(38,52,199)` 
        // this.ctx.fillStyle = `rgb(166,9,54)` 
        // this.ctx.fillStyle = ` rgb(95,36,246)` 
        // this.ctx.fillStyle = `rgb(195,34,109)` 
        // this.ctx.fillStyle = `rgb(28,241,196)` 
        // this.ctx.fillStyle = `rgb(127,142,148)` 
        // this.ctx.fillStyle = `rgb(30,62,186)` 
        // this.ctx.fillStyle = `rgb(127,142,148)` 
        // this.ctx.fillStyle = `rgb(172,95,149)` 
        //this.ctx.fillStyle = `rgb(108,238,228)` 
    
      

        //rgb(108,238,228)
        // rgb(219,185,37)
        //rgb(150,165,142)
        //rgb(237,200,156)
        //rgb(213,78,35)
        //rgb(172,9,74)
        // rgb(1,75,208)
        //rgb(147,5,113)
        this.ctx.fillStyle = `${this.color}`
        this.ctx.arc(0, 0, this.size * Math.random(), 0, Math.PI * 2, true)
        this.ctx.fill()
        this.ctx.closePath()
        this.ctx.restore()

        
    }
}

export default Point